const subscriptionAccessKeys = {
  // Access Status Messages
  "subscription.access.granted-through-another": "Your access to Be Your Best is granted through another account.",
  "subscription.access.no-active": "You have no active subscriptions. Please {{purchaseLink}} to continue using Be Your Best.",
  "subscription.access.purchase-link": "purchase a subscription",
  "subscription.access.demo-alert.trial-status": "You currently have trial access to Be Your Best.",
  "subscription.access.demo-alert.next-steps": "Next steps → Go to the Meta Quest App Store and download the Be Your Best app to your headset → Open the app in your headset, login and start training.",
  "subscription.access.demo-alert.purchase-prompt": "If you want the full experience, purchase a subscription {{purchaseLink}}.",
  "subscription.access.demo-alert.link": "here",
  "subscription.access.product-expiring": "Your {{productName}} subscription will expire on {{date}}.",
};

export const subscriptionAccess = {
  ...subscriptionAccessKeys,
};
